import { TComplexField, TDynamicFormConfig } from "./dynamic-edit-form";

export type Option = {
  section_name: string;
  fields: string[];
};

export function DEFAULT_ASSET_CLASS_OPTIONS_BUILDER(
  dynamicFormConfig: TDynamicFormConfig,
): Option[] {
  return Object.entries(
    (dynamicFormConfig?.asset_class_2 as TComplexField)?.select ?? {},
  )
    .map(([section_name, sub_field]) => ({
      section_name,
      fields: Object.entries(sub_field as Record<string, string | false>).map(
        ([key, value]) => (typeof value === "string" && value ? value : key),
      ),
    }))
    .filter((section) => section.fields.length > 0);
}
